<ng-container *transloco="let t; prefix: 'property-upload-wizard'">
  <div class="container flex flex-1 flex-col rfs:gap-28 items-center">
    <progress-stepper
      class="progress-stepper-onboarding"
      [StepNo]="1"
      [Steps]="Steps"
    ></progress-stepper>
    <div
      class="flex flex-col gap-12 items-center justify-center max-w-[800px] w-full"
    >
      <div class="flex flex-col gap-4">
        <h2 class="h2 rfs:text-[40px] text-center font-semibold text-black">
          {{ t("headers.stepOne") }}
        </h2>
        <p class="rfs:text-xl text-center font-light">
          {{ t("infoText.stepOne") }}
        </p>
      </div>
      <app-seller-property-type-buttons
        class="w-full"
        [IsMultiple]="false"
        [ToggledButtons]="selectedPropertyType ? [selectedPropertyType] : []"
        (SelectedItems)="propertyTypeSelected($event)"
      ></app-seller-property-type-buttons>

      @if (selectedPropertyType === propertyTypes.Apartment) {
      <app-apartment-options
        class="w-full"
        [floor]="floor"
        [floorType]="floorType"
        (SelectedItem)="apartmentFloorTypeSelected($event)"
      ></app-apartment-options>
      } @else if (selectedPropertyType && [propertyTypes.Villa, propertyTypes.Maisonette].includes(selectedPropertyType)) {
        <div class="w-full flex flex-col gap-3">
          <label class="font-semibold text-gray-950">
            {{t('labels.floors')}}
          </label>
          <div class="flex flex-col md:flex-row gap-3">
            <div class="w-[220px]">
              <app-floor-dropdown [dropdownItems]="floorOptions" [title]="t('placeholders.floorDropdown')" (onFloorSelected)="onFloorSelected($event)" [floor]="floor" [floorType]="floorType"></app-floor-dropdown>
            </div>
            <div class="w-[220px]">
              <app-floor-dropdown [dropdownItems]="numberOfFloorsOptions" [title]="t('placeholders.numberOfFloorsDropdown')" (onFloorSelected)="onNumberOfFloorsSelected($event)" [floor]="numberOfFloors" [floorType]="numberOfFloorsFloorType"></app-floor-dropdown>
            </div>
          </div>
        </div>
      }
      @if ( 
        (selectedPropertyType && selectedPropertyType !== propertyTypes.Apartment && ![propertyTypes.Villa, propertyTypes.Maisonette].includes(selectedPropertyType)) 
        || 
        (selectedPropertyType === propertyTypes.Apartment && floor != null)
        ||
        (selectedPropertyType && [propertyTypes.Villa, propertyTypes.Maisonette].includes(selectedPropertyType) && floor != null && numberOfFloors != null )
    )
     {
      <div class="w-full">
        <form id="property-wizard">
          <fieldset class="flex flex-col gap-3 group/input mb-12">
            <label
              class="font-semibold text-gray-950 group-disabled:text-gray-300"
              >{{t('labels.constructionYear')}}</label
            >
            <input
            #year
            type="number"
            numericOnly
            [value]="constructionYear"
            [min]="minConstructionYear"
            [max]="currentYear"
            (input)="ConstructionYearChanged(year)"
            class="bg-white max-w-[216px] text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
          />
          
          </fieldset>
          <fieldset class="flex flex-col gap-3 group/input">
            <label
              class="font-semibold flex gap-2 items-center text-gray-950 group-disabled:text-gray-300"
              >{{ t("labels.propertyArea") }}
              <i class="icon-info-circle self-center relative" [tooltip]="t('labels.propertyAreaTooltip')"></i>
            </label>
            <div
              class="flex flex-col lg:flex-row gap-4 lg:items-center justify-center"
            >
              <div class="min-w-[300px] flex-1">
                <label for="FloorSpace"></label>
                <input
                  [value]="propertyArea ?? 0"
                  placeholder=""
                  type="range"
                  #FloorSpace
                  min="0"
                  max="1000"
                  step="1"
                  (change)="AreaChanged(FloorSpace.value)"
                  (input)="AreaChanged(FloorSpace.value)"
                />
              </div>
              <div class="relative flex-1">
                <input
                  type="number"
                  numericOnly
                  #areaInput
                  placeholder=""
                  [value]="propertyArea"
                  name="area"
                  (input)="AreaChanged(areaInput.value)"
                  (change)="AreaChanged(areaInput.value)"
                  class="bg-white w-full text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
                />
                <span
                  class="absolute inset-y-0 right-5 flex items-center pl-2 text-gray-700"
                  >m²</span
                >
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      }
    </div>
  </div>
  <app-property-upload-navigation
    [HidePrevious]="true"
    [NextDisabled]="
      !selectedPropertyType ||
      !propertyArea ||
      (!constructionYear 
      || Number(constructionYear) < minConstructionYear 
      || Number(constructionYear) > currentYear)
      || (selectedPropertyType === propertyTypes.Apartment && floor == null)
      || ([propertyTypes.Villa, propertyTypes.Maisonette].includes(selectedPropertyType) && floor == null && numberOfFloors == null)"
    (NextButtonClicked)="SaveStep1()"
  ></app-property-upload-navigation>
</ng-container>
